import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'
import { mergeIds } from '@/utils'

const defaultParams = {
  from: moment().format('YYYY-MM-DD'),
  to: moment().add(30, 'days').format('YYYY-MM-DD'),
}
const module = 'bookings'
let doc = {
  list: {
    name: 'Réservations',
    hasMap: true,
    headers: [
      { label: 'En affichage', value: 'inUse' },
      { label: 'Client', value: 'basket.client.name' },
      { label: 'Code', value: 'face.board.code' },
      { label: 'Type', value: 'face.board.board_type.name' },
      { label: 'Adresse', value: 'face.board.adress' },
      { label: 'District', value: 'face.board.district.name' },
      { label: 'Ville', value: 'face.board.district.city.name' },
      { label: 'Region', value: 'face.board.district.city.region.name' },
      { label: 'Début', value: 'dateStart', orig: 'basket.date_start', card: false },
      { label: 'Fin', value: 'dateEnd', orig: 'basket.date_end', card: false },
      { label: 'Dates', value: 'dates', sortable: false, inTable: false, inDetail: false },
    ],
    actions: [
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    search: [
      { label: 'Client', type: 'text', name: 'client_id', classes: 'md4' },
      { label: 'Début', type: 'date', name: 'from', classes: 'md4' },
      { label: 'Fin', type: 'date', name: 'to', classes: 'md4' },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['bookings.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
  },

  form: {
    name: 'Réservation',
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['bookings.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        isFlat: true,
        scope: ['bookings.delete'],
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
    fields: [
      { label: 'Client', type: 'list', from: 'name', name: 'client_id', source: 'clients' },
      { label: 'Nom', type: 'text', name: 'name', hint: 'Nom du visuel' },
      { label: 'Début', type: 'date', name: 'date_start' },
      { label: 'Fin', type: 'date', name: 'date_end' },
    ],
  },

  postprocess: item => {
    let inUse = item.current_display_id ? 'Oui' : 'Non'
    let imgPath = item.face ? item.face.img_path : null
    let dateStart = item.basket
      ? moment(item.basket.date_start).format('DD/MM/YYYY')
      : null
    let dateEnd = item.basket
      ? moment(item.basket.date_end).format('DD/MM/YYYY')
      : null
    let position = item.face
      ? {lng: parseFloat(item.face.board.lon), lat: parseFloat(item.face.board.lat)}
      : undefined
    return {
      ...item,
      dateStart,
      dateEnd,
      dates: `${dateStart} - ${dateEnd}`,
      position,
      img_path: imgPath,
      inUse,
    }
  },

  params: {
    fetchAll: {include: 'basket.client,face.board.board_type,basket.status', ...defaultParams},
    fetchOne: {include: 'basket.client,face.board.board_type'},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  state: {
    search: {
      data: defaultParams,
    },
  },
  actions: {
    selectionReport: ({commit}, payload) => {
      const { data } = payload
      let bookingIds = mergeIds(data)
      let params = {id: bookingIds}
      commit('EXPORT_REQUEST', payload)
      const callBack = event => { commit('EXPORT_PROGRESS', event) }
      apiClient._download('bookings', `reports/bookings`, {}, params, callBack)
        .then(response => {
          commit('EXPORT_SUCCESS', response)
        })
        .catch(error => {
          commit('EXPORT_ERROR', error)
        })
    },

  },
}

export default merge(base, custom)
